import PropTypes from 'prop-types';
import React from 'react';

const Title = ({ text }) => {
  return <h1 className="text-light text-start mt-3 mt-md-5 mb-4">{text}</h1>;
};

Title.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired,
};

export default Title;
